/* eslint no-console:0 */

import { Application } from '@hotwired/stimulus'
import '@hotwired/turbo-rails'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import 'driver.js/dist/driver.css'
import '../stylesheets/application.sass'
import 'sentry'
import 'onesignal/index'
import 'common'
import 'bs/turbo_load'
import 'twitter/turbo_load'
import 'fontawesome'
import 'emoji/turbo_load'

const application = Application.start()

const context = require.context('controllers', true, /\.js$/)
application.load(definitionsFromContext(context))

require.context('../images', true)
